(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["Inkline"] = factory(require("vue"));
	else
		root["Inkline"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 